import { render, staticRenderFns } from "./LastClubs.vue?vue&type=template&id=a3c87d40&scoped=true&"
import script from "./LastClubs.vue?vue&type=script&lang=js&"
export * from "./LastClubs.vue?vue&type=script&lang=js&"
import style0 from "./LastClubs.vue?vue&type=style&index=0&id=a3c87d40&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3c87d40",
  null
  
)

export default component.exports